const root = document.documentElement;
const logoListElementsDisplayed = getComputedStyle(root).getPropertyValue('--logo-list-elements-displayed');
const logoListContent = document.querySelector('ul.logo-list-content');

const originalElements = Array.from(logoListContent.children);
const originalLength = originalElements.length;

root.style.setProperty('--logo-list-elements', originalLength * 4);

for (let i = 0; i < 2; i++) {
  originalElements.forEach((el) => {
    logoListContent.appendChild(el.cloneNode(true));
  });
}
